import React, { useRef, useEffect } from "react";

const Siteplan = React.memo(
  ({ salesLoading, justifyPillsTab, component }) => {
    const scaleRef = useRef(1);
    const positionRef = useRef({ x: 0, y: 0 });
    const startPosRef = useRef({ x: 0, y: 0 });
    const isDraggingRef = useRef(false);
    const innerRef = useRef(null);

    const applyTransform = () => {
      if (!innerRef.current) return;
      innerRef.current.style.transform = `translate(${positionRef.current.x}px, ${positionRef.current.y}px) scale(${scaleRef.current})`;
    };

    const handleStart = (e) => {
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      const clientY = e.touches ? e.touches[0].clientY : e.clientY;

      isDraggingRef.current = true;
      startPosRef.current = {
        x: clientX - positionRef.current.x,
        y: clientY - positionRef.current.y,
      };

      if (innerRef.current) {
        innerRef.current.style.transition = "none";
      }
    };

    const handleMove = (e) => {
      if (!isDraggingRef.current) return;

      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      const clientY = e.touches ? e.touches[0].clientY : e.clientY;

      positionRef.current = {
        x: clientX - startPosRef.current.x,
        y: clientY - startPosRef.current.y,
      };

      applyTransform();
    };

    const handleEnd = () => {
      isDraggingRef.current = false;
    };

    const zoomIn = () => {
      scaleRef.current += 0.1;
      if (innerRef.current) innerRef.current.style.transition = "transform 0.25s ease";
      applyTransform();
    };

    const zoomOut = () => {
      scaleRef.current = Math.max(0.1, scaleRef.current - 0.1);
      if (innerRef.current) innerRef.current.style.transition = "transform 0.25s ease";
      applyTransform();
    };

    const resetView = () => {
      positionRef.current = { x: 0, y: 0 };
      scaleRef.current = 1;

      if (innerRef.current) {
        innerRef.current.style.transition = "transform 0.25s ease";
        innerRef.current.style.transform = `translate(0px, 0px) scale(1)`;
      }
    };

    useEffect(() => {
      applyTransform();
    }, []);

    return (
      <>
        <div className="floating-btn d-flex gap-1">
          <div>
            <button type="button" className="btn btn-sm btn-soft-primary" onClick={zoomIn}>
              <i className="ri-zoom-in-line fs-15"></i>
            </button>
          </div>
          <div>
            <button type="button" className="btn btn-sm btn-soft-primary" onClick={zoomOut}>
              <i className="ri-zoom-out-line fs-15"></i>
            </button>
          </div>
          <div>
            <button type="button" className="btn btn-sm btn-soft-danger" onClick={resetView}>
              <i className="ri-find-replace-line fs-15"></i>
            </button>
          </div>
        </div>

        <div
          onMouseDown={handleStart}
          onMouseMove={handleMove}
          onMouseUp={handleEnd}
          onMouseLeave={handleEnd}
          onTouchStart={handleStart}
          onTouchMove={handleMove}
          onTouchEnd={handleEnd}
          style={{
            overflow: "hidden",
            paddingBottom: "10px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            cursor: isDraggingRef.current ? "grabbing" : "grab",
            userSelect: "none",
            position: "relative",
            backgroundColor: "white",
            border: "1px solid #ccc",
            borderRadius: "8px",
            marginBottom: "20px",
          }}
        >
          <div
            ref={innerRef}
            style={{
              width: "100%",
              height: "100%",
              transform: `translate(${positionRef.current.x}px, ${positionRef.current.y}px) scale(${scaleRef.current})`,
              transformOrigin: "center center",
            }}
          >
            <div>{component}</div>
          </div>
        </div>
      </>
    );
  },
  (prevProps, nextProps) => {
    return prevProps.salesLoading === nextProps.salesLoading && prevProps.justifyPillsTab === nextProps.justifyPillsTab;
  }
);

Siteplan.displayName = "Siteplan";
export default Siteplan;
